var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    Esta es la pagina de pruebas\n    "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('app-web-cam',{attrs:{"multiple":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }